<template>
  <div>
    <div class="activity-item" v-for="(item, index) in list" :key="index" @click="toUrl(item)">
      <div class="item-info">
        <!-- <div class="info-title">{{ item.activityType == 1 ? '新增门店Mapping' : item.activityType == 2 ? '更新门店Mapping信息' : [10, 11].includes(item.activityType) ? '提报 Pop up' : [12].includes(item.activityType) ? '取消 Pop up' : [13, 14].includes(item.activityType) ? 'Pop up 执行情况上报' : [20].includes(item.activityType) ? 'Pop up 执行情况上报' : '' }}</div> -->
        <div class="info-title">
          {{ activityTypeInfo[item.activityType] }}<span v-if="item.expandInfoJson">{{ item.expandInfoJson | formatExpandInfoJson({activityType: item.activityType }) }}</span>
        </div>
        <div class="info-desc">{{ item.localCreateTime }}</div>
      </div>
      <div class="create-name" :class="{'custom-name': [22, 23].includes(item.activityType) }">{{ item.createUserName }}</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapMutations } from 'vuex'
import i18n from '@/i18n'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatExpandInfoJson (val, params) {
      if (params.activityType === 60) {
        return val.user.nickName
      } else if (params.activityType === 15) {
        const newCustomerTag = val.customerTag.newCustomerTag
        return newCustomerTag === 0 ? i18n.t('shared.filter.toBeVerified') : newCustomerTag === 1 ? i18n.t('shared.filter.sVIPCore') : newCustomerTag === 2 ? i18n.t('shared.filter.vIPCore') : newCustomerTag === 3 ? i18n.t('shared.filter.potential') : ''
      } else if ([1101, 1102].includes(params.activityType)) {
        return val.scheduleTime
      }
      return ''
    }
  },
  data () {
    return {
      activityTypeInfo: {
        1: this.$t('shared.addNewStoreMapping'), // 新增门店Mapping
        2: this.$t('shared.updateStoreMappingInformation'), // 更新门店Mapping信息
        3: this.$t('shared.setStoreLabels'), // 设置门店标签
        10: this.$t('shared.launchPopUpEvent'), // 提报 Pop up
        11: this.$t('shared.updatePopUpEvent'), // 提报 Pop up
        12: this.$t('shared.cancelPopUpEvent'), // 取消 Pop up
        13: this.$t('shared.reportPopUpEventExecutionStatus'),
        14: this.$t('shared.sellOutDataMaintenance'), // Pop up 执行情况上报
        15: this.$t('shared.setStoreTag'), // 设置门店标签
        // 16: 'Kick out the store',
        17: this.$t('shared.materialSampleDeliveryDataMaintenance'),
        20: this.$t('shared.storeIncentiveInviteEmployeeToActivate'), // Store Incentive 邀约员工开通
        21: this.$t('shared.storeIncentiveDeactivateEmployeeAccount'), // Store Incentive 关闭员工账号
        22: this.$t('shared.storeIncentiveBindProduct'), // Store Incentive 绑定产品
        23: this.$t('shared.storeIncentiveUploadSalesProof'), // Store Incentive 上传销售凭证
        24: this.$t('shared.redeemIncentiveRewardsForEmployees'),
        30: this.$t('shared.addNewStoreVisit'), // 新增门店拜访
        31: this.$t('shared.updateStoreVisitInformation'), // 更新门店拜访信息
        32: this.$t('shared.setStoreTag'),
        40: this.$t('shared.newVisitSellIn'),
        41: this.$t('shared.updateVisitSellIn'),
        // 33: 'Kick out the store',
        50: this.$t('shared.newReOrder'),
        51: this.$t('shared.modifyReOrder'),
        60: this.$t('shared.storesAreTransferredAndAllocatedTo'), // 门店转移并分配给
        61: this.$t('shared.cancelAllocationOfStores'), // 取消分配门店
        62: this.$t('shared.setAssignedBABDInTheManagementSystem'), // '后台设置负责人 ',
        71: this.$t('shared.aplyToKickOutOfOperation'),
        72: this.$t('shared.agreeToApplicationForKickOutOfOperation'),
        73: this.$t('shared.rejectApplicationForKickingOutUpStore'),
        81: this.$t('shared.newDistributorMapping'),
        82: this.$t('shared.updateDistributorMapping'),
        83: this.$t('shared.setTheResponsiblePerson'), // '设置负责人 ',
        90: this.$t('shared.brandDayApplication'),
        91: this.$t('shared.modifyBrandDayApplicationInfo'),
        92: this.$t('shared.cancelBrandDay'),
        93: this.$t('shared.reportingOnTheBrandDayExecution'),
        1001: this.$t('shared.newDistributorVisit'),
        1002: this.$t('shared.updateDistributorVisit'),
        1101: this.$t('shared.addNewVisitSchedulePlannedVisitDate'),
        1102: this.$t('shared.cancelVisitSchedule')
      }
    }
  },
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO']),
    toUrl (params) {
      if ([10, 11].includes(params.activityType)) {
        this.$router.push(`/createEvent?eventId=${params.sourceId}&pageType=store&eventType=1`)
      } else if ([90, 91].includes(params.activityType)) {
        this.$router.push(`/createEvent?eventId=${params.sourceId}&pageType=salesDistribution&eventType=2`)
      } else if ([12, 92].includes(params.activityType)) {
        Toast(this.$t('tips.eventCancelled'))
      } else if ([13, 14, 15, 17, 93].includes(params.activityType)) {
        this.SET_EVENTINFO({ eventId: params.sourceId, schedule: '' })
        this.$router.push(`/eventDetail?eventId=${params.sourceId}&pageType=`)
      } else if ([20, 21].includes(params.activityType)) {
        this.$router.push(`/storeIncentive?customerId=${params.operationId}`)
      } else if ([22, 23].includes(params.activityType)) {
        this.$router.push(`/incentive/incentiveDetail?scanId=${params.sourceId}`)
      } else if (params.activityType === 24) {
        this.$router.push(`/pointsDetail?employeeId=${params.createUserId}&customerId=${params.sourceId}`)
      } else if ([30, 31, 32].includes(params.activityType)) {
        this.$router.push(`/storeMaintain/storeVisitDetail?visitId=${params.sourceId}`)
      } else if ([40, 41].includes(params.activityType)) {
        this.$router.push(`/storeExpansion/visitSellInDetail?visitId=${params.sourceId}`)
      } else if ([50, 51].includes(params.activityType)) {
        this.$router.push(`/storeMaintain/reOrderVisitDetail?visitId=${params.sourceId}`)
      } else if ([1, 2, 60, 61, 62].includes(params.activityType)) {
        this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${params.sourceId}&isRecord=record`)
      } else if ([71, 72, 73].includes(params.activityType)) {
        this.$router.push(`/storeMaintain/storeMappingDetail?customerId=${params.sourceId}&pageType=storeMaintain&activityType=${params.activityType}`)
      } else if ([81, 82, 83].includes(params.activityType)) {
        this.$router.push(`/salesDistribution/sdMappingDetail?customerId=${params.sourceId}`)
      } else if ([1001, 1002].includes(params.activityType)) {
        this.$router.push(`/salesDistribution/sdVisitDetail?visitId=${params.sourceId}`)
      } else if ([1101, 1102].includes(params.activityType)) {
        this.$router.push(`/visitPlan/detail?planId=${params.sourceId}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.activity-item {
  display: flex;
  align-items: center;
  background-color: #fff;
  margin-bottom: 1px; // Divider effect
  border-bottom: 1px solid #f0f0f0;
  padding: 10px;
  &:first-child {
    border-top: 1px solid #f0f0f0;
  }
  .item-info {
    flex: 1;
    display: flex;
    flex-direction: column;

    .info-title {
      font-size: 14px;
      color: #000;
      margin-bottom: 16px;
      .tag72 {
        color: #c4200b;
      }
    }

    .info-desc {
      font-size: 14px;
      color: #7f7f7f;
    }
  }
  .create-name {
    font-size: 14px;
    color: #307bff;
  }
  .custom-name {
    color: #ec541c;
  }
}
</style>
